import type { ColumnDef } from '@tanstack/react-table';
import { createActionsColumn, createSerialColumn } from '@/components/common/DataTable';
import { RowViewLink } from '@/components/common/RowActions';
import { formatDisplayDate } from '@/utils/date';
import type { SurveyListItem } from '../types/survey.types';
import { SurveyStatusBadge } from './SurveyStatusBadge';
import { NumericCell } from './NumericCell';

export function getSurveyColumns(): ColumnDef<SurveyListItem>[] {
  return [
    createSerialColumn<SurveyListItem>(),
    {
      accessorKey: 'title',
      header: 'Title',
      cell: ({ row }) => <span className="font-medium">{row.original.title}</span>,
    },
    {
      accessorKey: 'status',
      header: 'Status',
      cell: ({ row }) => <SurveyStatusBadge status={row.original.status} />,
    },
    {
      accessorKey: 'startDate',
      header: 'Start Date',
      cell: ({ row }) => formatDisplayDate(row.original.startDate),
    },
    {
      accessorKey: 'endDate',
      header: 'End Date',
      cell: ({ row }) => formatDisplayDate(row.original.endDate),
    },
    {
      accessorKey: 'questionCount',
      header: 'Questions',
      cell: ({ row }) => <NumericCell value={row.original.questionCount} />,
    },
    {
      accessorKey: 'respondentCount',
      header: 'Respondents',
      cell: ({ row }) => <NumericCell value={row.original.respondentCount} />,
    },
    {
      accessorKey: 'responseCount',
      header: 'Responses',
      cell: ({ row }) => <NumericCell value={row.original.responseCount} />,
    },
    {
      accessorKey: 'createdAt',
      header: 'Created',
      cell: ({ row }) => formatDisplayDate(row.original.createdAt),
    },
    createActionsColumn<SurveyListItem>((survey) => (
      <RowViewLink
        to="/feedback/surveys/$surveyId"
        params={{ surveyId: survey.id }}
        aria-label={`View ${survey.title}`}
      />
    )),
  ];
}
